<template>
    <Widget title="Devices"
        headerLink="devices"
        :iconSrc="require('../../../assets/images/home_icons/devices.png')"
    >
        <div class="row">
            <div class="col-6 align-self-end">
                <button class="btn btn-sm btn-light" @click="goToDevicesPage">
                    <i class="fas fa-list-ul"></i>
                    Device List
                </button>
            </div>
            <div class="col-6">
                <div class="row text-right" style="position: absolute; top: -0.75rem; right: 1rem;">
                    <div class="col-12">
                        <p class="m-0 p-0">Total: {{ device_total }}</p>
                    </div>
                    <div class="col-12 mb-1">
                        <p class="m-0 p-0">Registered:&nbsp;{{ device_registered_count }}&nbsp;/&nbsp;{{ device_sip_total }}</p>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <Devices :devices="devices" :callback="showEditDeviceModal"></Devices>
            </div>

            <div class="col-12">
                <AddToZone :devices="devices" :zones="zones" :callback="handleDeviceAddedToZone"></AddToZone>
            </div>  
        </div>

        <Modal modal_id="editDeviceModal">
            <template v-slot:title>
                <h2>Edit Device</h2>
            </template>
            <template v-slot:body>
                <EditDeviceForm v-if="device_edit_id" :device_id="device_edit_id" :callback="handleDeviceEdited"/>
            </template>
        </Modal>
    </Widget>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '../../Modal.vue';
import Widget from '../Widget.vue';
import Devices from './Devices.vue';
import AddToZone from './AddToZone.vue';
import EditDeviceForm from '../../../components/Device/EditDeviceForm.vue';
import DeviceListMixin from '../../../mixins/DeviceListMixin.vue';
import router from '../../../router';

export default {
    components: { Modal, Widget, Devices, EditDeviceForm, AddToZone },
    mixins: [DeviceListMixin],
    data() {
        return {
            device_edit_id: null
        }
    },
    computed: {
        ...mapGetters({
            zones: 'allZones',
        })
    },
    created() {
        this.$store.dispatch('getZones');
    },
    methods: {
        showEditDeviceModal(device_id) {
            this.device_edit_id = device_id;
            $('#editDeviceModal').modal('show');
        },
        hideEditDeviceModal() {
            this.device_edit_id = null;
            $('#editDeviceModal').modal('hide');
        },
        goToDevicesPage() {
            router.push('devices');
        },
        handleDeviceEdited(status) {
            if(status === 'success') {
                this.$store.dispatch('getDevices');
            }
            this.hideEditDeviceModal();
        },
        handleDeviceAddedToZone(deviceName, zoneName){
            this.device_edit_id = null;
            alert(`${deviceName} has been added to ${zoneName}.`);
        }
    }
}
</script>